@if (!(selectedMappedItem$$ | async)) {
    <div class="cb-margin">
        <div class="cb-margin-bottom flex-col">
            <form #form="ngForm">
                <div class="start-center flex-row flex">
                    <span class="flex"></span>
                    <cb-button
                        class="cb-margin"
                        (clicked)="createTakeoff()"
                        [disabled]="!(canCreateTakeOffTask$ | async)"
                    >
                        Create Takeoff
                    </cb-button>
                </div>
            </form>
        </div>
        <div class="scroll-container">
            @if (results$ | async; as results) {
                <div #listContainer class="list-container flex-wrap flex">
                    @if (results != null && results.length == 0) {
                        <cb-info-message
                            [message]="'There are no take offs'"
                            [icon]="'info_circle'"
                        ></cb-info-message>
                    }
                    @for (result of results | cbSortByPipe: 'createdDate' : 'desc'; track result) {
                        <div class="md-33 sm-50 xs-100 flex-25">
                            <cb-takeoff-card
                                (viewTakeOffTaskEventEmitter)="viewTakeOffTask($event)"
                                [mappedItem]="result"
                            >
                            </cb-takeoff-card>
                        </div>
                    }
                </div>
            } @else {
                <cb-loading-spinner message="Fetching results"> </cb-loading-spinner>
            }
        </div>
    </div>
}
@if (selectedMappedItem$$ | async) {
    <div class="cb-margin">
        <cb-takeoff-task
            [mappedItem]="selectedMappedItem"
            [lot]="lot$ | async"
            (goBack)="handleGoBack()"
            (reloadLotMappedItem)="reloadLotMappedItemOnParent()"
        >
        </cb-takeoff-task>
    </div>
}
